<template>
    <div class="template-wrapper">
		<h2 class="page-title">{{ $t("metaTemplate") }}</h2>
		<el-divider></el-divider>
		<el-button @click="dialogVisible = true" v-if="chatbot_setting_edit === '1'">{{ $t("addTemplate") }}</el-button>
    <template v-if="chatbot_setting_read === '1'">
      <br />
      <br />
      <el-form ref="storeform" :model="storeform">
        <el-form-item :label="$t('selectStore')">
          <template>
            <div class="" style="display: flex">
              <el-select v-model="storeform.storeid" placeholder="" @change="changeStoreid">
                <el-option :label="$t('all')" value="" v-if="storeid === null"></el-option>
                <el-option v-for="item in storelist" :label="item.storeid+' ('+item.name+')'" :value="item.storeid"></el-option>
              </el-select>
            </div>
          </template>
        </el-form-item>
      </el-form>
    </template>

    <template v-if="chatbot_setting_read === '1'">
      <el-table
        :data="
          tableData.slice((currentPage - 1) * pageSize, currentPage * pageSize)
        "
        stripe
        @sort-change="sortChange"
        style="width: 100%">
        <el-table-column prop="storeid" :label="$t('storeid')" sortable="custom" width="">
        </el-table-column>
        <el-table-column prop="template_name" :label="$t('templateName')" sortable="custom">
        </el-table-column>
        <el-table-column prop="operation" :label="$t('adminset')" align="center">
          <template slot-scope="scope">
            <div class="operationVid">
              <el-button @click="edititem(scope.row)" v-if="chatbot_setting_edit === '1'">{{ $t("edit") }}</el-button>
              <el-button @click="delitem(scope.row.id)" v-if="chatbot_setting_edit === '1'">{{ $t("delete") }}</el-button>
              <span v-if="chatbot_setting_edit === '0'">{{ $t("NoPermissions") }}</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination flex-center">
        <span class="el-pagination__total">{{ $t("total") }} {{tableData.length}} {{ $t("items") }}</span>
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="pageSize"
          layout="prev,pager,next"
          :total="tableData.length"
        ></el-pagination>
      </div>
    </template>
    <template v-if="chatbot_setting_read === '0'">
          <span>{{ $t("NoPermissions") }}</span>
      </template>

    <!-- add -->
    <el-dialog
      :title="$t('addTemplate')"
      :visible.sync="dialogVisible"
      :width="$store.state.isMobile? '90%' :'556px'"
      :before-close="handleClose"
    >
      <div class="add-template">
        <el-form ref="form" :model="form"> 
          <el-form-item :label="$t('storeList')">
						<el-select v-model="form.storeid" placeholder="">
							<el-option v-for="item in storelist" :label="item.name" :value="item.storeid"></el-option>
						</el-select>
					</el-form-item>
          <el-form-item :label="$t('templateName')">
            <el-input v-model="form.template_name"  rows="1"></el-input>
          </el-form-item>
		  <el-form-item :label="$t('image')">
				<el-input v-model="form.image"></el-input>
				<el-upload :limit="1" ref="elUpload" action="" list-type="picture-card" :auto-upload="true"
					:http-request="uploadSectionFile" :on-remove="handleRemove">
					<i slot="default" class="el-icon-plus" />
					<div slot="file" slot-scope="{file}">
						<el-image class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
						<span class="el-upload-list__item-actions">
							<span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
								<i class="el-icon-zoom-in" />
							</span>
							<span v-if="!disabled" class="el-upload-list__item-delete"
								@click="handleDownload(file)">
								<i class="el-icon-download" />
							</span>
							<span v-if="!disabled" class="el-upload-list__item-delete"
								@click="handleRemove(file)">
								<i class="el-icon-delete" />
							</span>
						</span>
					</div>
				</el-upload>
			</el-form-item>
		  <el-form-item   :label="$t('wenzi')+'1'">
		   <el-input v-model="form.text1"   :rows="1"></el-input>
		 </el-form-item>
		 <el-form-item  :label="$t('wenzi')+'2'">
		   <el-input v-model="form.text2"   :rows="1"></el-input>
		 </el-form-item>
     <el-form-item :label="$t('isCatalog')">
						<el-select v-model="form.isCatalog" :placeholder="$t('pleaseSelect')">
							<el-option :label="$t('no')" value="0">
              </el-option>
              <el-option :label="$t('yes')" value="1">
              </el-option>
						</el-select>
					</el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{ $t("Cancel") }}</el-button>
        <el-button type="primary" @click="sure">{{
          $t("Sure")
        }}</el-button>
      </span>
    </el-dialog>

    <!-- edit -->
    <el-dialog
      :title="$t('templateName')"
      :visible.sync="dialogEditFormVisible"
      :width="$store.state.isMobile? '90%' :'556px'"
      :before-close="handleClose"
    >
      <div class="add-template">
        <el-form ref="editform" :model="editform"> 
          <el-form-item :label="$t('storeList')">
						<el-select v-model="editform.storeid" placeholder="">
							<el-option v-for="item in storelist" :label="item.name" :value="item.storeid"></el-option>
						</el-select>
					</el-form-item>
          <el-form-item :label="$t('templateName')">
            <el-input v-model="editform.template_name" rows="1"></el-input>
          </el-form-item>
          <el-form-item :label="$t('image')">
				<el-input v-model="editform.image"></el-input>
				<el-upload :limit="1" ref="elUpload" action="" list-type="picture-card" :auto-upload="true"
					:http-request="uploadEditSectionFile" :on-remove="handleRemove">
					<i slot="default" class="el-icon-plus" />
					<div slot="file" slot-scope="{file}">
						<el-image class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
						<span class="el-upload-list__item-actions">
							<span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
								<i class="el-icon-zoom-in" />
							</span>
							<span v-if="!disabled" class="el-upload-list__item-delete"
								@click="handleDownload(file)">
								<i class="el-icon-download" />
							</span>
							<span v-if="!disabled" class="el-upload-list__item-delete"
								@click="handleRemove(file)">
								<i class="el-icon-delete" />
							</span>
						</span>
					</div>
				</el-upload>
			</el-form-item>
		  <el-form-item   :label="$t('wenzi')+'1'">
		   <el-input v-model="editform.text1"   :rows="1"></el-input>
		 </el-form-item>
		 <el-form-item  :label="$t('wenzi')+'2'">
		   <el-input v-model="editform.text2"   :rows="1"></el-input>
		 </el-form-item>
     <el-form-item :label="$t('isCatalog')">
						<el-select v-model="editform.isCatalog" :placeholder="$t('pleaseSelect')">
							<el-option :label="$t('no')" value="0">
              </el-option>
              <el-option :label="$t('yes')" value="1">
              </el-option>
						</el-select>
					</el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogEditFormVisible = false">{{ $t("Cancel") }}</el-button>
        <el-button type="primary" @click="edit">{{
          $t("Sure")
        }}</el-button>
      </span>
    </el-dialog>


    </div>
</template>
<script>
import { formatDate } from '../../assets/date.js'
import {tongyong, getStore, getMetaTemplate, addMetaTemplate, imageUpload} from '@/api'
export default {
  data() {
    return {
      chatbot_setting_read: '0',
        chatbot_setting_edit: '0',
        exportcsv: '0',
        qyid: '',
        storeid: '',
      show:false,
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      dialogVisible: false,
      dialogEditFormVisible: false,
      tableData: [
      
      ],
      form: {
        qyid: "",
        storeid: "",
        template_name: "",
        text1: "",
        text2: "",
        isCatalog: 0,
        image: "",
        action: ""
      },
      editform: {
        id: "",
        qyid: "",
        storeid: "",
        template_name: "",
        text1: "",
        text2: "",
        isCatalog: 0,
        image: "",
        action: ""
      },
      huodonglist:[],
      storelist: [],
      storeform: {
				storeid: ''
			},

    };
  },
  filters: {
    formatDate: function (time) {
            time = time * 1000     //注意：time应为格式为13位unix時間戳，如果是10位的unix時間戳，需要乘以1000
            let date = new Date(time)
            return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
      } 
    },
  created() {
	  var user = JSON.parse(window.localStorage.getItem("userinfo"));
	  //console.log(user)
	  //this.qyid = user.id
    var auser = JSON.parse(window.localStorage.getItem('auserinfo'))
    this.qyid = auser.qyid
    this.storeid = auser.storeid
    if(auser.storeid) {
        this.storeform.storeid = auser.storeid
    }
    this.chatbot_setting_read = auser.chatbot_setting_read
    this.chatbot_setting_edit = auser.chatbot_setting_edit
    this.exportcsv = auser.exportcsv
    this.getlist(auser.storeid);
    this.gethuodonglist()
    this.getstorelist();
  },

  methods: {
    handleCurrentChange(val) {
      this.currentPage = val;
    },
    handleClose() {
      this.dialogVisible = false;
      this.dialogEditFormVisible = false;
    },
	handlePictureCardPreview() {

	},
	uploadSectionFile(params) {
				const file = params.file,
					fileType = file.type,
					isImage = fileType.indexOf('image') !== -1,
					isLt2M = file.size / 1024 / 1024 < 2;
				// 这里常规检验，看项目需求而定
				if (!isImage) {
					this.$message.error(this.$t('imageFormatOnly'));
					return;
				}
				if (!isLt2M) {
					this.$message.error(this.$t('imageSizeOnly'));
					return;
				}
				// 根据后台需求数据格式
				const form1 = new FormData();
				// 文件对象
				form1.append('file', file);
				// 本例子主要要在请求时新增特定属性，所以要用自己方法覆盖默认的action
				// form.append("clientType", 'xxx');
				// 项目封装的请求方法，下面做简单介绍


				imageUpload(form1).then(res => {
					//自行处理各种情况
					console.log('res', res)
					this.form.image = res
          //this.editform.image = res
				}).catch(() => {
					// xxx
				});
			},
    uploadEditSectionFile(params) {
				const file = params.file,
					fileType = file.type,
					isImage = fileType.indexOf('image') !== -1,
					isLt2M = file.size / 1024 / 1024 < 2;
				// 这里常规检验，看项目需求而定
				if (!isImage) {
					this.$message.error(this.$t('imageFormatOnly'));
					return;
				}
				if (!isLt2M) {
					this.$message.error(this.$t('imageSizeOnly'));
					return;
				}
				// 根据后台需求数据格式
				const form1 = new FormData();
				// 文件对象
				form1.append('file', file);
				// 本例子主要要在请求时新增特定属性，所以要用自己方法覆盖默认的action
				// form.append("clientType", 'xxx');
				// 项目封装的请求方法，下面做简单介绍


				imageUpload(form1).then(res => {
					//自行处理各种情况
					console.log('res', res)
					//this.form.image = res
          this.editform.image = res
				}).catch(() => {
					// xxx
				});
			},
      handleRemove() {
        
      },
    getlist(storeid) {
		this.show=true
      console.log("go list");
      var user = JSON.parse(window.localStorage.getItem("userinfo"));



      let fdata = {
        qyid: this.qyid,
        storeid: storeid
        };
        getMetaTemplate(fdata).then((res) => {
        if (res.code == 1) {
          console.log(res);
          this.tableData = res.data;
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
		this.show=false
      });




    },
    getstorelist() {
				console.log('go taocan');
				var user = JSON.parse(window.localStorage.getItem('userinfo'))

				let fdata = {
					qyid: this.qyid,
                    storeid: this.storeid
				};
				getStore(fdata).then((res) => {
					if (res.code == 1) {
						console.log(res);
						this.storelist = res.data
					} else {
						this.$message({
							type: "error",
							message: res.msg,
						});
					}
				});
			},
			changeStoreid() {
				console.log('storeid:' + this.storeform.storeid)
				this.getlist(this.storeform.storeid)
			},
    gethuodonglist() {
				console.log('go taocan');
				var user = JSON.parse(window.localStorage.getItem('userinfo'))
				console.log("user")
				console.log(user)

				let fdata = {
					sjk: 'messenger_huodong_yhq',
					action: 'list',

					//qyid: user.id
                    qyid: this.qyid
				}
				tongyong(fdata).then(res => {
					if (res.code == 1) {
						console.log(res);
						this.huodonglist = res.data
					} else {
						this.$message({
							type: 'error',
							message: res.msg
						})
					}
				})
			},
    sure() {
      var user = JSON.parse(window.localStorage.getItem("userinfo"));
      console.log(user)
    
	  if(!this.form.template_name) {
	  		    this.$message.error("請輸入範本名稱");
	  		   return
	  }
      
      //this.form.qyid= user.id
      this.form.qyid= this.qyid
      this.form.action= "add"
	  
      
      addMetaTemplate(this.form).then((res) => {
        if (res.code == 1) {
          this.$message({
            type: "success",
            message: res.msg,
          });
          this.dialogVisible = false;
          this.getlist(this.storeform.storeid);
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      });
    },
    edit() {
      var user = JSON.parse(window.localStorage.getItem("userinfo"));
      console.log(user)
    
	  if(!this.editform.template_name) {
	  		    this.$message.error(this.$t("pleaseEnterTemplateName"));
	  		   return
	  }
      
      //this.editform.qyid= user.id
      this.editform.qyid= this.qyid
      this.editform.action= "edit"
	  
      
      addMetaTemplate(this.editform).then((res) => {
        if (res.code == 1) {
          this.$message({
            type: "success",
            message: res.msg,
          });
          this.dialogEditFormVisible = false;
          this.getlist(this.storeform.storeid);
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      });
    },
    edititem(data) {
				this.editform = data
				this.dialogEditFormVisible = true
        console.log("data")
        console.log(data)
		},
    delitem(id) {
      this.$confirm(this.$t('deleteConfirm'), {
				confirmButtonText: this.$t('Sure'),
				cancelButtonText: this.$t('Cancel')
			}).then(_ => {

					console.log('del..');
          var user = JSON.parse(window.localStorage.getItem("userinfo"));
					let deletedata = {
						action: 'delete',
						id: id,
                        //qyid: user.id
                        qyid: this.qyid
					}
					addMetaTemplate(deletedata).then((res) => {
            if (res.code == 1) {
              this.$message({
                type: "success",
                message: res.msg,
              });
              this.dialogEditFormVisible = false;
              this.getlist(this.storeform.storeid);
            } else {
              this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
				}).catch(_ => {



				})


			},
      sortChange({ prop, order }) {
      this.tableData.sort(this.compare(prop,order));
    },
    compare (propertyName, sort) {
      return function (obj1, obj2) {
        var value1 = obj1[propertyName]
        var value2 = obj2[propertyName]
        if (typeof value1 === 'string' && typeof value2 === 'string') {
          const res = value1.localeCompare(value2, 'zh')
          return sort === 'ascending' ? res : -res
        } else {
          if (value1 <= value2) {
            return sort === 'ascending' ? -1 : 1
          } else if (value1 > value2) {
            return sort === 'ascending' ? 1 : -1
          }
        }
      }
    }
  },
  



};
</script>
<style lang="scss" scoped>
.el-pagination__total {
	display: inline-block;
	font-size: 13px;
	min-width: 35.5px;
	height: 28px;
	line-height: 28px;
	vertical-align: top;
	box-sizing: border-box;
}
.pendingList-wrapper {
}
.pagination {
width: 100%;
margin: 30px auto;
}
::v-deep .el-select {
width: 100%;
}
</style>